module.exports = __webpack_public_path__ + "static/beni-steven-6187dbce5a047272428ae10f147af556.png";